import type { TiposSeleccionFiltroStock } from "../../../hooks/Api/Articulos";

interface IndicadoresCantidadesProps {
	readonly data: CantidadesStock;
	readonly setFiltroStock: (value: TiposSeleccionFiltroStock) => void;
}
export function IndicadoresCantidades(props: IndicadoresCantidadesProps) {
	const { data } = props;

	const clickMinimo = () => props.setFiltroStock("minimo");
	const clickMaximo = () => props.setFiltroStock("maximo");
	const clickRoturaStock = () => props.setFiltroStock("roturaStock");

	return (
		<div className="contenedorIndicadores">
			<div onClick={clickMinimo} className="piher-bg clicable">
				<h2>Bajo mínimo</h2>
				<h1>{data.bajoMinimo}</h1>
				<img src="/img/icons/arrowright.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickMaximo} className="piher-bg clicable">
				<h2>Sobre máximo</h2>
				<h1>{data.sobreMaximo}</h1>
				<img src="/img/icons/arrowright.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickRoturaStock} className="piher-bg clicable">
				<h2>Rotura de stock</h2>
				<h1>{data.roturaStock}</h1>
				<img src="/img/icons/arrowrightGrey.svg" className="arrow-icon" alt="Ver más" />
			</div>
		</div>
	);
}



export interface CantidadesStock {
	bajoMinimo: number | string;
	sobreMaximo: number | string;
	roturaStock: number | string;
	ofCount: number | string;
}
